import styled from 'styled-components';
// import { bg_home } from '../../../utils/config';

export const PaveColor = {
  white: '#fff',
  black: '#000',
  danger: '#ff4d4f',
  damages_lv_1: '#718093',
  damages_lv_2: '#f9ca24',
  damages_lv_3: '#f0932b',
  damages_lv_4: '#e84118',
  disabled: '#acb0b7',
  textColor: '#bbbec5',
  bgColorGray: '#edeeef',
  primary_green: '#27d089',
  primary_violet: 'rgba(46,25,62,1)',
  primary_violet_opacity: 'rgba(46,25,62,.7)',
};

export const WrapHomeHeader = styled.div`
  background: ${(props) => props.bgImg};
`;

export const WrapContent = styled.section`
  color: black;
  background: #fff;
  position: relative;
  padding: 40px;
  z-index: 2;
  overflow: hidden;
  text-align: center;
  /* height: calc(100vh); */
  h5 {
    font-size: 13px;
    font-weight: 700;
    margin: 0 0 20px 0;
  }
  p {
    font-size: 14px;
  }
  .photo {
    width: 120px;
    margin: 40px auto;
    img {
      width: 100%;
    }
  }
`;
export const WrapMessage = styled.span`
  background: ${PaveColor.primary_violet_opacity};
  display: block;
  padding: 7px 11px;
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0.25px;
  border-radius: 5px;
  color: #fff;
  &:first-letter {
    text-transform: uppercase;
  }
`;
export const WrapUserImage = styled.span`
  width: 120px;
  display: block;
  height: 0;
  margin-left: -13px;
  margin-top: -20px;
  img {
    width: 100%;
  }
`;

export const WrapOption = styled.div`
  position: fixed;
  bottom: ${(props) => (props.bottom ? props.bottom : '30px')};
  /* right: 0; */
  width: 100%;
  padding: 0 30px;
  z-index: 100;
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
`;

export const WrappEdit = styled.div`
  position: relative;
  i {
    position: absolute;
    top: 7px !important;
    right: 7px !important;
  }
`;
export const ScreenShotView = styled.div`
  position: absolute;
  z-index: 1;
  top: 0;
  width: 100%;
  height: 100vh;
  #captured-video {
    display: block !important;
  }
  img {
    /* height: 100vh; */
    /* object-fit: cover; */
    max-width: 100%;
    max-height: 100%;
    width: 100%;
  }
`;
export const TutsView = styled.div`
  /* position: relative;
    top: -38px; */
  height: calc(100vh);
  // height: 100%;
  width: 100%;
  z-index: 3;
  opacity: 0.6;
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  display: flex;
  justify-content: center;
  position: absolute;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  .wrapp-image {
    text-align: center;
    /* max-height: 270px; */
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      max-width: 100%;
      max-height: 100%;
      width: 100%;
      overflow: hidden;
    }
    svg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    .isvg {
      position: absolute;
      width: 100%;
      height: 100%;
      svg {
        width: 100%;
        height: 100%;
      }
    }
  }
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset 0 0 192px 20px #000;
  box-shadow: inset 0 0 192px 20px #000;
`;

export const FlexStyle = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const Btn = styled.div`
  position: relative;
  transition: all 0.5s ease;
  .ripple {
    background-position: center;
    transition: background 0.8s;
    &:hover {
      background: #47a7f5 radial-gradient(circle, transparent 1%, #47a7f5 1%)
        center/15000%;
    }
    &:active {
      background-color: #6eb9f7;
      background-size: 100%;
      transition: background 0.3s;
    }
  }
`;

export const Guide = styled.div`
  section {
    span {
      border: solid #27d089;
      border-width: 0 3.5px 3.5px 0;
      display: inline-block;
      padding: 3.5px;
      position: absolute;
      z-index: 2;
      transition: all 0.5s ease;
      &:nth-child(1) {
        transform: rotate(-180deg);
        -webkit-transform: rotate(-180deg);
        top: 15px;
        left: 15px;
      }
      &:nth-child(2) {
        transform: rotate(270deg);
        -webkit-transform: rotate(270deg);
        right: 15px;
        top: 15px;
      }
      &:nth-child(3) {
        bottom: 15px;
        right: 15px;
      }
      &:nth-child(4) {
        transform: rotate(-270deg);
        -webkit-transform: rotate(-270deg);
        left: 15px;
        bottom: 15px;
      }
    }
  }
  section.transition {
    span {
      &:nth-child(1) {
        top: 45%;
        left: 47%;
      }
      &:nth-child(2) {
        right: 47%;
        top: 45%;
      }
      &:nth-child(3) {
        bottom: 45%;
        right: 46.9%;
      }
      &:nth-child(4) {
        left: 47%;
        bottom: 45%;
      }
    }
  }
`;
export const circleStyle = {
  display: 'block',
  width: '25px',
  height: '25px',
  border: '2px solid rgb(255, 255, 255)',
  lineHeight: '23px',
  textAlign: 'center',
  borderRadius: '50%',
  fontSize: '13px',
};

export const WrappCamera = styled.div`
  position: fixed;
  top: 0;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-contents: center;
  z-index: ${(props) => props.zIndex};
  video {
    width: 100vw;
    object-fit: ${(props) => props.isLandscape ? 'contain' : 'cover'};
    object-position: center
  }
`;
export const titleStyle = {
  fontSize: '16px',
  textTransform: 'uppercase',
  fontWeight: 'bold',
  letterSpacing: '3px',
  margin: ' 30px 0',
  padding: '0 10px',
};
export const middleStyle = {
  textAlign: 'left',
  verticalAlign: 'middle',
  textTransform: 'capitalize',
  padding: '12px 0',
};

export const h5Style = {
  textTransform: 'capitalize',
};
export const tdStyleMiddle = {
  verticalAlign: 'middle',
  padding: '5px',
};

export const lableStyle = {
  width: '100%',
  margin: '0',
};

export const inputStyle = {
  position: 'absolute',
  top: '0',
  left: '0',
  right: '0',
  margin: 'auto',
  bottom: '0',
  opacity: '0',
  width: '100%',
};

export const switchStyle_2 = {
  display: 'flex',
  justifyContent: 'left',
  alignItems: 'center',
  textAlign: 'center',
};

export const liteStyle_3 = {
  background: `#fff`,
  padding: '0px 20px',
};

export const WrappAntStyle = styled.div`
  .ant-progress-line {
    position: absolute;
    top: -8px;
    width: 100%;
    left: 0;
    right: 0;
  }
  .ant-progress-show-info .ant-progress-outer {
    margin: 0 !important;
    padding: 0 !important;
  }
  .ant-progress-outer .ant-progress-inner {
    margin-top: 0;
  }
  span.ant-progress-text {
    display: none;
  }
  .ant-upload-picture-card-wrapper {
    zoom: 0;
    display: block;
  }
  i.anticon.anticon-close {
    display: none;
  }
  .ant-upload-list-item-info {
    &::before {
      display: none;
    }
  }
  i.anticon.anticon-delete {
    display: none;
  }
  img.ant-upload-list-item-image {
    border-radius: 4px;
  }
  .ant-upload-list-picture-card .ant-upload-list-item {
    width: 120px;
    height: 120px;
    position: relative;
  }
  .ant-upload-list-picture .ant-upload-list-item,
  .ant-upload-list-picture-card .ant-upload-list-item {
    padding: 5px;
  }
  .ant-upload.ant-upload-select-picture-card {
    width: 120px;
    height: 120px;
  }
  .ant-upload.ant-upload-select-picture-card:hover {
    border-color: rgb(39, 208, 137);
  }
`;

export const pStyle = {
  color: '#e9ecef',
  letterSpacing: '1px',
  position: 'relative',
  marginBottom: '0',
  fontSize: 12,
  textTransform: 'uppercase',
  fontWeight: '700',
};
